var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPhotograph(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M3.2001 2.39999C2.77575 2.39999 2.36878 2.56856 2.06873 2.86862C1.76867 3.16868 1.6001 3.57565 1.6001 3.99999V12C1.6001 12.4243 1.76867 12.8313 2.06873 13.1314C2.36878 13.4314 2.77575 13.6 3.2001 13.6H12.8001C13.2244 13.6 13.6314 13.4314 13.9315 13.1314C14.2315 12.8313 14.4001 12.4243 14.4001 12V3.99999C14.4001 3.57565 14.2315 3.16868 13.9315 2.86862C13.6314 2.56856 13.2244 2.39999 12.8001 2.39999H3.2001ZM12.8001 12H3.2001L6.4001 5.59999L8.8001 10.4L10.4001 7.19999L12.8001 12Z",
    fill: "#09090B"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPhotograph);
export default __webpack_public_path__ + "static/media/Photograph.bdf0da868dda80924c11c43ccf20e885.svg";
export { ForwardRef as ReactComponent };